<script setup lang="ts">
import {
  UICheckbox,
  UIModal,
  UIModalFooter,
  UIModalHeader,
} from '@gohighlevel/ghl-ui'
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import ConflictingCalendarsTable from './ConflictingCalendarsTable.vue'

const { t } = useI18n()

defineProps<{
  show: boolean
  items: Array<{ name: string; group: string }>
  groupName: string
  onCancel: () => void
  onConfirm: () => void
}>()

const state = reactive({
  consent: false,
})
</script>

<template>
  <UIModal :show="show" :width="590" class="z-50">
    <template #header>
      <UIModalHeader
        :type="'primary'"
        :title="t('settings.calendar.conflicting_calendars')"
        @close="onCancel"
      />
    </template>

    <div>
      <div
        class="text-[14px] font-normal text-gray-600"
        v-html="
          t('settings.calendar.conflicting_calendars_description', {
            name: groupName,
          })
        "
      />

      <ConflictingCalendarsTable :items="items" />

      <div class="mb-[10px] mt-[20px]">
        <UICheckbox v-model:checked="state.consent" size="medium">
          <div class="text-[14px] font-normal text-gray-500">
            {{
              t('settings.calendar.move_calendar_consent', { name: groupName })
            }}
          </div>
        </UICheckbox>
      </div>
    </div>

    <template #footer>
      <UIModalFooter
        :positive-text="t('settings.calendar.confirm')"
        :negative-text="t('settings.calendar.cancel')"
        :type="'primary'"
        :disabled="!state.consent"
        @positive-click="onConfirm"
        @negative-click="onCancel"
      />
    </template>
  </UIModal>
</template>
